import {getItemDiscount} from '@/services/Order/orderItemOverview'
import {useQueries} from '@tanstack/react-query'

export const useItemDiscount = () => {
  const results = useQueries({
    queries: [{queryKey: ['ORDER_ITEM_OVERVIEW_ITEM_DISCOUNT'], queryFn: getItemDiscount}],
  })

  const {itemDiscountJsonSchema, itemDiscountUISchema} = results?.[0]?.data || {}

  return {
    itemDiscountJsonSchema,
    itemDiscountUISchema,
  }
}
